import { Hourglass } from "lucide-react";
import loaderIcon from "./icons/loader-animation.svg";
import { ILoaderComponent } from "types/gaiaComponents/loader";

export enum LoaderSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large'
}

export const Loader = (props: ILoaderComponent) => {

    return (
        <div className={`ga-loader ga-loader--${props.size}`} data-cy={props.dataCy} role={props.role} aria-hidden={props.ariaHidden}>
            <img
                src={loaderIcon}
                alt="Loader Animation"
                className="ga-loader__icon ga-loader__icon--animated"
            />
            <Hourglass
                aria-hidden={true}
                className="ga-loader__icon ga-loader__icon--reduced-motion"
            />
            {props.text && <span className="ga-loader__label">{props.text}</span>}
        </div>
    );
};

Loader.displayName = "Loader";
